// import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, DodgerBlueColor} from '../../cmsMainStyle'

const drawingRegisterStyle = theme => ({
	
})


export default drawingRegisterStyle